module.exports = __webpack_public_path__ + "img/g5.311fe576.png";